import EmailWithMetrics from "@mapmycustomers/shared/types/email/EmailWithMetrics";
import { Activity } from "@mapmycustomers/shared/types/entity";

import getEmailMetricsCounts, { EmailMetricsCounts } from "./getEmailMetricsCounts";

export type ActivityEmailMetrics =
  | { counts: EmailMetricsCounts; type: "aggregate" }
  | { log: EmailWithMetrics | null; type: "single" };

const getActivityEmailMetrics = (activity: Activity): ActivityEmailMetrics => {
  const logs = activity.emailLogs ?? [];

  if (logs.length > 1) {
    return { counts: getEmailMetricsCounts(logs), type: "aggregate" };
  }

  return { log: logs[0] ?? activity.emailLog ?? null, type: "single" };
};

export default getActivityEmailMetrics;
